"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderPayload = void 0;
var omit_1 = __importDefault(require("lodash/omit"));
var isBpUrl = function (str) {
    var re = /^\/api\/.*\/bots\/.*\/media\/.*/g;
    return re.test(str);
};
// Duplicate of modules/builtin/src/content-types/_utils.js
var formatUrl = function (baseUrl, url) {
    if (isBpUrl(url)) {
        return "".concat(baseUrl).concat(url);
    }
    else {
        return url;
    }
};
var renderPayload = function (payload) {
    var type = payload === null || payload === void 0 ? void 0 : payload.type;
    if (type === 'single-choice' && payload.choices) {
        return renderChoicePayload(payload);
    }
    else if (type === 'dropdown') {
        return renderDropdownPayload(payload);
    }
    else if (type === 'image' && payload.image) {
        return renderImagePayload(payload);
    }
    else if (type === 'audio' && payload.audio) {
        return renderAudioPayload(payload);
    }
    else if (type === 'video' && payload.video) {
        return renderVideoPayload(payload);
    }
    else if (type === 'file' && payload.file) {
        return renderFilePayload(payload);
    }
    else if (type === 'card') {
        return renderCarouselPayload(__assign(__assign({}, payload), { items: [payload] }));
    }
    else if (type === 'carousel' && payload.items) {
        return renderCarouselPayload(payload);
    }
    return payload;
};
exports.renderPayload = renderPayload;
var renderChoicePayload = function (content) {
    if (content.isDropdown) {
        return {
            type: 'custom',
            module: 'extensions',
            component: 'Dropdown',
            message: content.text,
            buttonText: '',
            displayInKeyboard: !content.displayInMessage,
            options: content.choices.map(function (c) { var _a; return ({ label: c.title, value: (_a = c.value) === null || _a === void 0 ? void 0 : _a.toUpperCase() }); }),
            width: !content.displayInMessage && 300,
            placeholderText: content.dropdownPlaceholder,
            disableFreeText: content.disableFreeText
        };
    }
    return {
        type: 'custom',
        module: 'channel-web',
        component: 'QuickReplies',
        quick_replies: content.choices.map(function (c) {
            var _a;
            return ({
                title: c.title,
                payload: (_a = c.value) === null || _a === void 0 ? void 0 : _a.toUpperCase()
            });
        }),
        disableFreeText: content.disableFreeText,
        wrapped: __assign({ type: 'text' }, (0, omit_1.default)(content, 'choices', 'type')),
        displayInMessage: content.displayInMessage
    };
};
var renderDropdownPayload = function (content) {
    return {
        type: 'custom',
        module: 'extensions',
        component: 'Dropdown',
        message: content.message,
        buttonText: content.buttonText,
        displayInKeyboard: content.displayInKeyboard,
        options: content.options,
        allowCreation: content.allowCreation,
        allowMultiple: content.allowMultiple,
        width: content.width,
        collectFeedback: content.collectFeedback,
        placeholderText: content.placeholderText,
        markdown: content.markdown
    };
};
var renderImagePayload = function (content) {
    return {
        type: 'image',
        title: content.title,
        url: formatUrl('', content.image),
        collectFeedback: content.collectFeedback
    };
};
var renderAudioPayload = function (content) {
    return {
        type: 'audio',
        title: content.title,
        url: formatUrl('', content.audio),
        collectFeedback: content.collectFeedback
    };
};
var renderVideoPayload = function (content) {
    return {
        type: 'video',
        title: content.title,
        url: formatUrl('', content.video),
        collectFeedback: content.collectFeedback
    };
};
var renderFilePayload = function (content) {
    return {
        type: 'file',
        title: content.title,
        url: formatUrl('', content.file),
        collectFeedback: content.collectFeedback
    };
};
var renderCarouselPayload = function (content) {
    return {
        text: ' ',
        type: 'carousel',
        collectFeedback: content.collectFeedback,
        elements: content.items.map(function (card) { return ({
            title: card.title,
            picture: card.image ? formatUrl('', card.image) : null,
            subtitle: card.subtitle,
            buttons: (card.actions || []).map(function (a) {
                var _a;
                if (a.action === 'Say something') {
                    return {
                        type: 'say_something',
                        title: a.title,
                        text: a.text
                    };
                }
                else if (a.action === 'Open URL') {
                    return {
                        type: 'open_url',
                        title: a.title,
                        url: (_a = a) === null || _a === void 0 ? void 0 : _a.url.replace('BOT_URL', '')
                    };
                }
                else if (a.action === 'Postback') {
                    return {
                        type: 'postback',
                        title: a.title,
                        payload: a.payload
                    };
                }
                else {
                    throw new Error("Webchat carousel does not support \"".concat(a.action, "\" action-buttons at the moment"));
                }
            }),
            markdown: card.markdown
        }); })
    };
};
